import { render } from "./quoting-electricity.vue?vue&type=template&id=5ec3c422&scoped=true"
import script from "./quoting-electricity.vue?vue&type=script&lang=js"
export * from "./quoting-electricity.vue?vue&type=script&lang=js"

import "./quoting-electricity.vue?vue&type=style&index=0&id=5ec3c422&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec3c422"]])

export default __exports__